import React, { useState, useEffect } from 'react';
import '../styles/SchoolList.css'; // CSSファイル

const schools = [
  "Harrow School",
  "St. Paul's School",
  "Rugby School",
  "North London Collegiate School",
  "Haberdashers' Aske's Boys' School",
  "Harrow International School Bangkok",
  "Harrow International School Appi",
  "Highgate School",
  "Taunton School",
  "South Hampstead High School",
  "University College School (UCS)",
  "North Bridge House School",
  "Holland House School"
];

const SchoolList = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleSchools = isMobile && !isExpanded ? schools.slice(0, 4) : schools;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="school-list-container">
      {/* タイトルとアイコンを1つのエレメントにまとめる */}
      <div className="school-list-title-wrapper">
        <div className="school-list-icons">
          <img src="/wp-content/uploads/2024/10/award_left.svg" alt="Award Icon Left" className="award-icon" />
        </div>
        <h4 className="school-list-title">合格＆支援実績</h4>
        <div className="school-list-icons">
          <img src="/wp-content/uploads/2024/10/award_right.svg" alt="Award Icon Right" className="award-icon" />
        </div>
      </div>

      {visibleSchools.map((school, index) => (
        <div className="school-item" key={index}>
          <img src="/wp-content/uploads/2024/10/crown_795197.svg" alt="School Icon" className="school-icon" />
          <span className="school-name">{school}</span>
        </div>
      ))}

      {isMobile && (
        <p className="toggle-text" onClick={handleToggle}>
          {isExpanded ? '閉じる' : 'もっと見る'}
        </p>
      )}
    </div>
  );
};

export default SchoolList;

